import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "mini-wizard-gift-cards-box" }
const _hoisted_2 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass($options.captionClass)
      }, [
        _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardGiftCardValueText) + " ", 1 /* TEXT */),
        _createVNode(_component_tooltip, {
          text: _ctx.Resources.ProjectHome.MiniWizardGiftCardValueTooltip
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_icon, {
              name: "circle-info",
              class: "_ml-h"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["text"])
      ], 2 /* CLASS */),
      _createElementVNode("strong", {
        class: _normalizeClass($options.amountClass),
        "data-qa": "available-gift-cards-box:Amount"
      }, _toDisplayString($options.giftCardBalanceFormatted), 3 /* TEXT, CLASS */)
    ])
  ]))
}